module.exports = __webpack_public_path__ + "img/email_icon.4b212020.svg";